import { useEffect, useState } from "react";

// True once the reader has scrolled past the dossier header block, so
// floating controls (Previous / Jump) never cover the title, hero or
// folder metadata at the top of the page.
export const usePastHeader = (threshold = 480) => {
  const [past, setPast] = useState(false);
  useEffect(() => {
    const onScroll = () => setPast(window.scrollY > threshold);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [threshold]);
  return past;
};

export default usePastHeader;
